import React, { PropTypes, Component } from 'react';
import { Link } from 'react-router-dom';
// import StarRatingComponent from 'react-star-rating-component';
import { connect } from 'react-redux';
// import { history } from 'react-router';
import { bindActionCreators } from 'redux';
import * as documentUploadActions from '../../../actions/documentUploadActions';
import * as constant from '../../../constants/constant';
import Pagination from "react-js-pagination";
import Moment from 'react-moment';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import AppointmentDocs from '../../sitemanagement/appointmentDocs';
import $ from "jquery";
import './../../../styles/css/newDocument.css'
import * as dashboardActions from "../../../actions/dashboardActions";
import { Form, Button, Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import userTime from './../../../images/userTime.png'
import arrow from './../../../images/arrow3.png'
import completed from './../../../images/completed.png'
import pending from './../../../images/pending.png'



export class SaaSContract extends Component {

    constructor(props) {
        super(props)
    
        this.state = {
             contract: ""
        }
    }
    

    render() {
        return (
           
                <CardContent style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column',padding: '30px 0px'}}>
                                     


                                    
                                
                                <div className="contractDiv">
                                        <Card>

                                            <CardContent>
                                                <Row className="card-head">
                                                    <img src={arrow} height="50" onClick={this.props.goBack}/>

                                                    <Typography variant="h4">SaaS Contract</Typography>
                                                    
                                                </Row>
                                                <hr color="lavender" />

                                                <div className="actual-Doc">

                                            { this.state.contract? <img src={contract} height="100%" width="100%"/> :<Typography style={{fontFamily:'sansation_regular'}} variant="h5">Ahmet & Vynika to provide</Typography>}

                                        </div>

                                        <div className="agreeBtn">
                                            <a>I agree</a>
                                            </div>

                                            </CardContent>

                                           



                                           







                                        </Card>

                                </div>








                                 </CardContent>
            
        )
    }
}



//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		specialistDocument: state.uploadDocument.specialistDocument ? state.uploadDocument.specialistDocument.data : [],
		totalCount: state.uploadDocument.specialistDocument ? state.uploadDocument.specialistDocument.totalCount : 0,
		success: state.uploadDocument.specialistDocument ? state.uploadDocument.specialistDocument.success : false,
		isProfileSaved: state.uploadDocument.specialistDocument ? state.uploadDocument.specialistDocument.isProfileSaved : false,
		isVettingTriggered: state.uploadDocument.specialistDocument ? state.uploadDocument.specialistDocument.isVettingTriggered : false,
	};
}
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(documentUploadActions, dispatch),
		logoutAction: bindActionCreators(dashboardActions, dispatch)

	};
}
export default connect(mapStateToProps, mapDispatchToProps)(SaaSContract);
